import React from 'react'
import BackgroundImageComponent from '../../shared/components/BackgroundImageComponent'
import { Button, Grid2, Typography } from '@mui/material'
import { Constants } from '../../shared/constants'
import useResponsive from '../../shared/utils/Responsive'

const KnowMoreSection = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <BackgroundImageComponent imageUrl={Constants.customImages.TwoBrothers} lineargradient={"linear-gradient(279.52deg, rgba(0, 0, 0, 0) 4.45%, #000000 98.98%)"} >
            <Typography variant='h2' color='primary.main'>On Boarding <Typography variant='h2' component={"span"} color='#FF8F8F'>Made Easy!</Typography></Typography>
            <Typography variant='body1' color='primary.main' mb={3} mt={1.5} width={{ xs: "auto", lg: "55%" }}>{isSmallScreen ? "Experience a hassle-free onboarding process designed for your comfort. From key handovers to utility setups." : " Experience a hassle-free onboarding process designed for your comfort. From key handovers to utility setups, we take care of everything so you can settle into your new home with ease."}</Typography>
 {!isSmallScreen &&
                <Grid2 container>
                    <Grid2 children size={3.5}>
                        <Button variant='contained' fullWidth>Onboard Now</Button>
                    </Grid2>

                </Grid2>
            }
            {isSmallScreen && <Button variant='contained' fullWidth>Onboard Now</Button>}
        </BackgroundImageComponent>
    )
}

export default KnowMoreSection